var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMulti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9412 75.7009H62.3235V64.1538H74.2353C75.1125 64.1538 75.8235 64.8924 75.8235 65.8034V75.7009H78.2059C78.6445 75.7009 79 76.0701 79 76.5256V78.1752C79 78.6307 78.6445 79 78.2059 79H25.7941C25.3555 79 25 78.6307 25 78.1752V76.5256C25 76.0701 25.3555 75.7009 25.7941 75.7009H28.1765V61.6795C28.1765 60.7685 28.8875 60.0299 29.7647 60.0299H41.6765V75.7009H44.0588V54.2564C44.0588 53.3454 44.7699 52.6068 45.6471 52.6068H58.3529C59.2301 52.6068 59.9412 53.3454 59.9412 54.2564V75.7009ZM48.3078 43.7024C46.7512 44.5523 45.1395 43.32 45.4344 41.5342L46.1396 37.264L43.1525 34.2399C41.8932 32.9649 42.5236 30.9922 44.25 30.7316L48.3781 30.1086L50.2242 26.2235C51.0025 24.5856 53.0037 24.5987 53.7758 26.2235L55.6219 30.1086L59.75 30.7316C61.4903 30.9943 62.0967 32.9752 60.8475 34.2399L57.8604 37.264L58.5656 41.5342C58.8628 43.3344 57.2364 44.5455 55.6922 43.7024L52 41.6863L48.3078 43.7024Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/Multi.5319240ec252633d538f30fa1fce8824.svg";
export { ForwardRef as ReactComponent };